import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import { useWidgetData } from "./WidgetDataContext";
import TradingGoalsPage from "../../trading-goals/TradingGoalsPage";

export default function DisciplineGoalsWidget() {
  const { isDark, t } = useWidgetData();
  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.dashboard.widgets.disciplineGoals} isDark={isDark} compact />
      <CardContent className="flex-1 overflow-auto px-4 pb-4 pt-0">
        <TradingGoalsPage />
      </CardContent>
    </Card>
  );
}
